enum ETaxationSystem {
  NDS_IS_INCLUDED = 'nds_is_included',
  NDS_IS_EXCLUDED = 'nds_is_excluded',
  SKOLKOVO_RESIDENT = 'skolkovo_resident',
}

export default ETaxationSystem;
